/**
 * @description: 大转盘抽奖组件
 */

import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import LuckyWheel, { LuckyWheelAction } from "@/components/LuckyWheel";
import styles from "./style.module.less";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";
import { Loading, Toast } from "@xp-design/mobile";
import { userPrizeDraw } from "@/api/configPage";
import useGetLoaclIp from "@/hooks/useGetLocalIP/useGetLoaclIp";
import { prizeDialogData } from "../../tool";
import LotteryBtn from "../../../lotteryBtn";
import NameList from "../../../nameList";
import CountDown from "../../../countDown";

interface WheelProps {
  pageInfo: any;
  activityInfo: any;
  activityStatusList: any;
  actInfo: any;
  btnUrl: string;
  afterDraw?: (prizeData: any) => void;
}

interface WheelRef {
  play: () => void;
}

const Wheel = forwardRef<WheelRef, WheelProps>(
  (
    { pageInfo, activityInfo, activityStatusList, actInfo, afterDraw, btnUrl },
    ref,
  ) => {
    const luckyRef = useRef<LuckyWheelAction>();
    const { localIP } = useGetLoaclIp();
    const isPlaying = useRef(false);
    const nameListRef = useRef<any>(null);
    const [downTime, setDownTime] = useState("");
    const [prizeMaskShow, setPrizeMaskShow] = useState(false);

    useEffect(() => {
      setDownTime(
        actInfo?.lotteryActivityDto?.activityEndTime?.replace(/-/g, "/"),
      );
    }, [actInfo]);

    const nameListCom = (isNeedBack = true) => {
      return (
        !["3-3", "4"].includes(actInfo?.lotteryActivityDto?.activityStatus) &&
        pageInfo?.elementSwitch?.switchData[2]?.val === "1" && (
          <NameList
            isNeedBack={isNeedBack}
            activityCode={pageInfo?.base?.[0]?.val?.valCode}
            ref={nameListRef}
          />
        )
      );
    };

    const timeCountdown = (bgUrl) => {
      return (
        !["3-3", "4"].includes(actInfo?.lotteryActivityDto?.activityStatus) &&
        pageInfo?.elementSwitch?.switchData[1]?.val === "1" &&
        new Date().getTime() >
          new Date(
            actInfo?.lotteryActivityDto?.activityBeginTime?.replace(/-/g, "/"),
          ).getTime() && <CountDown bgUrl={bgUrl} endTime={downTime} />
      );
    };

    const handlePlay = async () => {
      console.log(activityInfo);
      if (isPlaying.current) {
        return;
      }
      isPlaying.current = true;
      setPrizeMaskShow(true);
      setContentOverflow(true);
      trackGdp("P20189", "B004", {
        trackName: "充电_营销专题页_组件点击",
        origin: getChannel(),
        userType: "",
        versionId: activityInfo.versionCode,
        pageId: activityInfo.pageCode,
        ComponentCode: activityInfo.moduleId,
        type: activityInfo.moduleType,
        activityId: pageInfo.base[0].val.valCode,
        comp_style: JSON.parse(activityInfo.moduleJson).visual?.visualData[0]
          ?.typeName,
        status:
          activityStatusList[actInfo?.lotteryActivityDto?.activityStatus] || "",
        clickLocation: "抽奖按钮",
        remain_times: actInfo?.lotteryUserCountDto?.[0]?.remainingTimes,
      });
      try {
        // Loading.show("加载中...");
        const res: any = await userPrizeDraw({
          activityCode: pageInfo?.base?.[0]?.val?.valCode,
          ip: localIP,
        });
        if (res.code === 200) {
          luckyRef.current?.play();
          const { productCode } = res.data;
          const index = pageInfo?.prizes?.prizeData?.findIndex(
            (item) => item.productCode === productCode,
          );
          luckyRef.current?.stop(index);

          const pData = await new Promise((resolve) => {
            setTimeout(() => {
              resolve(prizeDialogData(res.data, pageInfo));
              // 抽奖 默认旋转时间为5秒 5秒后再展示中将结果
            }, 5200);
          });
          afterDraw?.(pData);
          nameListRef?.current?.refresh(pageInfo?.base?.[0]?.val?.valCode); // 更新走马灯内容
        } else {
          Toast.show({
            content: res.msg,
          });
        }
      } catch (error: any) {
        console.log(error);
      } finally {
        // Loading.hide();
        isPlaying.current = false;
        setPrizeMaskShow(false);
        setContentOverflow(false);
      }
    };

    const setContentOverflow = (hidden: boolean) => {
      document.body.style.overflow = hidden ? "hidden" : "auto";
      document.body.style.pointerEvents = hidden ? "none" : "";
      const configPage = document.getElementById("configPage");
      if (configPage) {
        configPage.style.overflow = hidden ? "hidden" : "auto";
      }
    };

    useImperativeHandle(ref, () => ({
      play: handlePlay,
    }));

    const wheelConfig = useMemo(
      () => ({
        winText: "",
        // 转盘背景
        blocks: [
          {
            imgs: [
              {
                src: pageInfo?.visual?.prizeSetting[0].content[1].val,
              },
            ],
          },
        ],
        // 奖品配置
        prizes: pageInfo?.prizes?.prizeData.map((item) => ({
          imgs: [{ src: item.val, width: "108rem", height: "108rem" }],
        })),
        // 指针图片设置
        pointerImg: {
          src: pageInfo?.visual?.prizeSetting?.[0]?.content?.[2]?.val,
        },
      }),
      [pageInfo],
    );

    return (
      <>
        {nameListCom()}
        {timeCountdown(pageInfo?.visual?.prizeSetting?.[0]?.content?.[7]?.val)}
        <div className={styles.LuckyWheel}>
          <LuckyWheel ref={luckyRef} {...wheelConfig} />
          <LotteryBtn
            onOpenPlay={handlePlay}
            btnUrl={btnUrl}
            showCount={pageInfo?.elementSwitch?.switchData[0]?.val === "1"}
            count={actInfo?.lotteryUserCountDto?.[0]?.remainingTimes}
          />
        </div>
        {prizeMaskShow && <div className={styles.prizeMask}></div>}
      </>
    );
  },
);

export default Wheel;
